import COLORS from '@mlb/react-patterns/v4/style/universal.color';
import BaseStyles, { PREFIX } from './base';
import { css } from 'styled-components';

const {
    mlbBlack,
    mlbWhite,
    mlbGrey3,
    mlbGrey4,
    mlbGrey7,
    mlbGrey5
} = COLORS;

export const DARK_COLORS = {
    grey5: '#040506',
    grey4: '#0B0F13',
    grey3: '#131A20',
    grey2: '#263340',
    grey1: '#B6B7B8',
    blue1: '#4B75A0',
    blue2: '#5CA5FF',
    blue3: '#006EF5',
    error: '#F16966',
    success: '#5EB15C',
    yellow: '#FFB833',
    toastGrey: '#232931'
};

/* to be tokenized with react patterns upgrades */
export const alertRed = '#AA0013';
const positiveGreen = '#5EB15C';
const primaryWhite = '#F4F5F6';
const secondaryGrey = '#959DA8';
const dividerColor = '#333B44';
const backgroundColor = '#14191F';
const alertYellow = '#E0A561';
const alertBlue = '#0062E3';

const DarkStyles = css`
  ${BaseStyles}
  :scope {
    --${PREFIX}-primary-font-color: ${mlbWhite};
    --${PREFIX}-secondary-font-color: ${DARK_COLORS.grey1};
    --${PREFIX}-tab-button-active-color: ${mlbWhite};
    --${PREFIX}-tab-button-inactive-color: ${DARK_COLORS.grey1};
    --${PREFIX}-title-color: ${DARK_COLORS.grey1};
    --${PREFIX}-recap-color: ${mlbWhite};
    --${PREFIX}-video-carousel-more-background: ${mlbGrey7};
    --${PREFIX}-background-color: ${DARK_COLORS.grey3};
    --${PREFIX}-play-dot-background: ${mlbGrey7};
    --${PREFIX}-play-outs-color: ${DARK_COLORS.grey1};
    --${PREFIX}-summary-play-event-color: ${DARK_COLORS.grey1};
    --${PREFIX}-summary-play-event-border-color: rgba(255, 255, 255, 0.2);
    --${PREFIX}-top-performer-stat-color: ${mlbGrey3};
    --${PREFIX}-morecoverage-date-color: ${mlbGrey4};
    --${PREFIX}-filter-button-bgcolor: ${DARK_COLORS.grey3};
    --${PREFIX}-filter-button-border: ${DARK_COLORS.grey2};
    --${PREFIX}-filter-button-fontcolor: ${mlbWhite};
    --${PREFIX}-filter-button-hover-bgcolor: ${mlbWhite};
    --${PREFIX}-filter-button-hover-border: ${mlbWhite};
    --${PREFIX}-filter-button-hover-fontcolor: ${mlbBlack};
    --${PREFIX}-scaffold-header-title-color: ${mlbWhite};
    --${PREFIX}-medlialinks_title-color: ${mlbWhite};
    --${PREFIX}-broadcaster-text-color: ${mlbGrey3};
    --${PREFIX}-boxscore-thead-color: ${DARK_COLORS.grey1};
    --${PREFIX}-boxscore-tbody-color: ${mlbWhite};
    --${PREFIX}-panel-border-color: ${mlbGrey4};
    --${PREFIX}-panel-svg-fill: ${mlbGrey4};
    --${PREFIX}-ls-decisions-border-color: ${DARK_COLORS.grey2};
    --${PREFIX}-live-background-color: ${DARK_COLORS.grey4};
    --${PREFIX}-live-element-background-color: ${DARK_COLORS.grey3};
    --${PREFIX}-boxscore-player-link-color: ${mlbWhite};
    --${PREFIX}-divider-color: ${DARK_COLORS.grey2};
    --${PREFIX}-matchup-outline-color: ${DARK_COLORS.grey2};
    --${PREFIX}-basepath-inactive-color: ${DARK_COLORS.grey1};
    --${PREFIX}-hover-close-color: ${DARK_COLORS.grey3};
    --${PREFIX}-overlay-background-color: ${DARK_COLORS.grey3};
    --${PREFIX}-summary-play-icon-color: ${DARK_COLORS.grey1};
    --${PREFIX}-table-active-cell-color: ${DARK_COLORS.grey2};
    --${PREFIX}-decisions-stats-color: ${DARK_COLORS.grey1};
    --${PREFIX}-team-stats-footer-color: ${DARK_COLORS.grey1};
    --${PREFIX}-gameover-divider-color: ${DARK_COLORS.grey2};
    --${PREFIX}-wrap-section-divider: ${DARK_COLORS.grey2};
    --${PREFIX}-play-dot-border: ${DARK_COLORS.grey2};
    --${PREFIX}-card-title-color: ${mlbWhite};
    --${PREFIX}-fv-how-to-title-color: ${mlbWhite};
    --${PREFIX}-summary-event-score-color: ${DARK_COLORS.blue2};
    --${PREFIX}-link-color: ${DARK_COLORS.blue2};
    --${PREFIX}-audio-list-link-hover-color: ${DARK_COLORS.blue2};
    --${PREFIX}-skeleton-background: ${DARK_COLORS.grey4};
    --${PREFIX}-skeleton-highlight: ${DARK_COLORS.grey3};
    --${PREFIX}-header-menu-border-color: ${DARK_COLORS.grey2};
    --${PREFIX}-green: ${DARK_COLORS.success};
    --${PREFIX}-red: ${DARK_COLORS.error};
    --${PREFIX}-film-room-font: ${DARK_COLORS.blue2};
    --${PREFIX}-oot-scoreboard-border-hover: ${DARK_COLORS.grey1};
    --${PREFIX}-oot-scoreboard-border-selected: ${DARK_COLORS.grey1};
    --${PREFIX}-oot-scoreboard-border-disabled: ${DARK_COLORS.grey1};
    --${PREFIX}-fv-login-link-color: ${DARK_COLORS.blue2};
    --${PREFIX}-fv-login-password-modal-bg: ${DARK_COLORS.grey4};
    --${PREFIX}-fv-login-password-modal-text: ${DARK_COLORS.grey1};
    --${PREFIX}-fv-login-error-message-bg: #9f3b32;
    --${PREFIX}-fv-login-error-message-text: #f4dedc;
    --${PREFIX}-scoreboard-notable-game-highlight: ${DARK_COLORS.blue1};
    --${PREFIX}-video-carousel-button-color: ${DARK_COLORS.grey4};
    --${PREFIX}-video-carousel-button-color-hover: ${DARK_COLORS.grey3};
    --${PREFIX}-button-solid-background: ${DARK_COLORS.blue3};
    --${PREFIX}-button-solid-text-color: mlbWhite;
    --${PREFIX}-button-hollow-background: transparent;
    --${PREFIX}-button-hollow-text: ${mlbWhite};
    --${PREFIX}-button-hollow-border: ${mlbWhite};
    --${PREFIX}-wrap-seeall-color: ${mlbWhite};
    --${PREFIX}-highlight-active-color: ${DARK_COLORS.blue2};
    --${PREFIX}-team-comparison-secondary-font-color: ${mlbGrey4};
    --${PREFIX}-scoreboard-button-color: ${mlbWhite};
    --${PREFIX}-accordion-indicator-color: ${DARK_COLORS.blue2};
    --${PREFIX}-dfvbuttons-bg-color: ${mlbGrey5};
    --${PREFIX}-dfvbuttons-active-color: ${DARK_COLORS.grey3};
    --${PREFIX}-dfvbuttons-active-text-color: ${mlbWhite};
    --${PREFIX}-dfv-batterview-text-color: ${mlbWhite};
    --${PREFIX}-dfv-batterview-bg-color: ${DARK_COLORS.grey3};
    --${PREFIX}-gamepicker-button-disabled: ${DARK_COLORS.grey1};
    --${PREFIX}-basepath-color: ${mlbWhite};
    --${PREFIX}-outs-color: ${mlbWhite};
    --${PREFIX}-active-icon-button-color: ${mlbWhite};
    --${PREFIX}-inactive-icon-button-color: ${DARK_COLORS.grey1};
    --${PREFIX}-toast-background-color: ${DARK_COLORS.toastGrey};
    --${PREFIX}-toast-border-color: ${DARK_COLORS.toastGrey};

    --${PREFIX}-fv-how-to-img-filter: 1;
    --${PREFIX}-overlay-opacity: 0.50;
    --${PREFIX}-overlay-midinning-opacity: 0.25;

    --${PREFIX}-alert-red: ${alertRed};
    --${PREFIX}-alert-yellow: ${alertYellow};
    --${PREFIX}-alert-blue: ${alertBlue};

    --${PREFIX}-game-context-button-color: ${primaryWhite};
    --${PREFIX}-game-context-primary-text-color: ${primaryWhite};
    --${PREFIX}-game-context-secondary-text-color: ${secondaryGrey};
    --${PREFIX}-game-context-divider-color: ${dividerColor};
    --${PREFIX}-game-context-background-color: ${backgroundColor};
    --${PREFIX}-ticket-button-color: ${positiveGreen};
    --${PREFIX}-tag-label-background: ${primaryWhite};
    --${PREFIX}-tag-label-text: ${mlbBlack};
    --${PREFIX}-game-context-primary: ${primaryWhite};
    --${PREFIX}-error-fallback-button-text: ${mlbBlack};
    --${PREFIX}-error-fallback-button-background: ${primaryWhite};
    --${PREFIX}-error-fallback-button-disabled: ${DARK_COLORS.grey1};

    color-scheme: dark;
    body {
        background-color: ${mlbBlack};
    }

  }
`;

export default DarkStyles;
